import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/EncounterIndex";

export interface EncounterIndex {
  id: number;
  register_id: string;
  pasien_rm: string;
  class: string;
  started_at: any;
  ended_at: any;
  created_at: string;
  updated_at: string;
  participants: Participants[];
}

export interface Participants {
  id: number;
  encounter_id: string;
  role: string;
  user_id: string;
  c_doc_id: string;
  created_at: string;
  updated_at: string;
}

export interface ServicedPasien {
  encounter_id: number;
  register_id: string;
  pasien_rm: string;
  pasien: {
    rm: string;
    nama: string;
    tgl_lahir: string;
    jenis_kelamin: string;
  };
  unit: {
    id: string;
    nama: string;
  };
  role: string;
  accepted_konsul: boolean;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "encounter-index"
})
class EncounterIndexStore extends VuexModule {
  loading = false;
  encRanap: EncounterIndex = null;
  servicedPasien: ServicedPasien[] = [];

  get encRanapParticipant() {
    return this.encRanap?.participants;
  }

  get encRanapParticipantByRole() {
    return {
      dpjp: this.encRanapParticipant.filter(it => it.role === "dpjp"),
      raber: this.encRanapParticipant.filter(it => it.role === "raber"),
      konsul: this.encRanapParticipant.filter(it => it.role === "konsul")
    };
  }

  @Mutation
  SET_RECORD(val) {
    this.encRanap = val;
  }

  @Mutation
  SET_SERVICED_PASIEN(val) {
    console.log("set serviced pasien", val);
    this.servicedPasien = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_SESSION() {
    this.encRanap = null;
  }

  @Mutation
  RESET_ALL() {
    this.encRanap = null;
    this.servicedPasien = [];
  }

  @Action({ rawError: true })
  async getEncounterRanap(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getEncounterRanap(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    console.log("store get encounter", response?.data);

    this.SET_RECORD(response?.data);
  }

  @Action({ rawError: true })
  async getPasienRanapDilayani(): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getPasienRanapDilayani().finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_SERVICED_PASIEN(response?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_SESSION();
  }

  @Action({ rawError: true })
  resetAll(): void {
    this.RESET_ALL();
  }
}

export default getModule(EncounterIndexStore);
